/* CharmFlip™ — Theme JS */
(function () {
  'use strict';

  /* ── Scroll-triggered nav ────────────────────────────── */
  const nav = document.querySelector('.cf-nav');
  if (nav) {
    const onScroll = () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile hamburger menu ───────────────────────────── */
  const navToggle = document.querySelector('.cf-nav__toggle');
  if (nav && navToggle) {
    navToggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-menu-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      navToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.querySelectorAll('.cf-nav__links a').forEach((a) => {
      a.addEventListener('click', () => {
        nav.classList.remove('is-menu-open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── Scroll reveal ───────────────────────────────────── */
  const reveals = document.querySelectorAll('.cf-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach((el) => observer.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Respect reduced motion ──────────────────────────── */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Cart Drawer ─────────────────────────────────────── */
  const cartDrawer = document.querySelector('.cf-cart-drawer');
  const cartOverlay = document.querySelector('.cf-cart-overlay');
  const cartClose   = document.querySelector('.cf-cart-drawer__close');
  const cartNavLink = document.querySelector('.cf-nav__cart');

  function openCart() {
    if (!cartDrawer) return;
    fetchCart();
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  if (cartNavLink) {
    cartNavLink.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  }

  // Open the drawer when Horizon adds/updates the cart (commerce pages).
  if (cartDrawer) {
    document.addEventListener('cart:update', function (e) {
      if (e && e.detail && e.detail.source === 'cf-drawer') return; // avoid self-trigger loops
      openCart();
    });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => renderCart(cart))
      .catch(() => {});
  }

  function updateCartCount(count) {
    if (cartNavLink) {
      cartNavLink.setAttribute('aria-label', 'Cart (' + count + ' item' + (count === 1 ? '' : 's') + ')');
    }
    const badge = document.querySelector('.cf-nav__cart-count');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  function renderCart(cart) {
    const body  = document.querySelector('.cf-cart-drawer__body');
    const footer = document.querySelector('.cf-cart-drawer__footer');
    if (!body) return;

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cf-cart-drawer__empty">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';

    body.innerHTML = cart.items.map((item) => `
      <div class="cf-cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.product_title}" class="cf-cart-item__img" loading="lazy">
        <div class="cf-cart-item__info">
          <p class="cf-cart-item__title">${item.product_title}</p>
          <p class="cf-cart-item__variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <div class="cf-cart-item__row">
            <p class="cf-cart-item__price">${formatMoney(item.final_line_price)}</p>
            <div class="cf-cart-item__qty">
              <button class="cf-cart-qty-btn" data-key="${item.key}" data-action="minus" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button class="cf-cart-qty-btn" data-key="${item.key}" data-action="plus" aria-label="Increase">+</button>
            </div>
          </div>
        </div>
        <button class="cf-cart-item__remove" data-key="${item.key}" aria-label="Remove">&times;</button>
      </div>
    `).join('');

    const subtotalEl = document.querySelector('.cf-cart-drawer__subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Qty buttons in drawer
    body.querySelectorAll('.cf-cart-qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const currentItem = cart.items.find((i) => i.key === key);
        if (!currentItem) return;
        const newQty = btn.dataset.action === 'plus'
          ? currentItem.quantity + 1
          : Math.max(currentItem.quantity - 1, 0);
        updateCartItem(key, newQty);
      });
    });

    // Remove buttons
    body.querySelectorAll('.cf-cart-item__remove').forEach((btn) => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => renderCart(cart))
      .catch(() => {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Product variant picker ──────────────────────────── */
  const productSection = document.querySelector('.cf-product');
  if (productSection) {
    const primaryImg   = productSection.querySelector('.cf-product__img--primary img');
    const priceEl      = productSection.querySelector('.cf-product__price');
    const variantInput = productSection.querySelector('input[name="id"]');
    const thumbs       = productSection.querySelectorAll('.cf-product__thumb');
    const addToCartBtn = productSection.querySelector('.cf-product__cta');

    const primaryVideo = productSection.querySelector('#cf-product-primary-video');

    // Show the still image, pausing the 360 loop to free the decoder.
    function showImage() {
      if (!primaryVideo || !primaryImg) return;
      primaryVideo.pause();
      primaryVideo.classList.add('is-hidden');
      primaryVideo.parentElement.classList.remove('is-video');
      primaryImg.classList.remove('is-hidden');
    }

    // Show the looping 360 video.
    function showVideo() {
      if (!primaryVideo) return;
      if (primaryImg) primaryImg.classList.add('is-hidden');
      primaryVideo.classList.remove('is-hidden');
      primaryVideo.parentElement.classList.add('is-video');
      const p = primaryVideo.play();
      if (p && p.catch) p.catch(() => {});
    }

    function swapImage(src) {
      if (!primaryImg || !src) return;
      showImage();
      primaryImg.style.opacity = '0';
      setTimeout(() => {
        primaryImg.removeAttribute('srcset');
        primaryImg.removeAttribute('sizes');
        primaryImg.src = src;
        primaryImg.style.opacity = '1';
      }, 200);
    }

    function setAvailability(available) {
      if (!addToCartBtn) return;
      if (available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
        addToCartBtn.classList.remove('is-sold-out');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
        addToCartBtn.classList.add('is-sold-out');
      }
    }

    // ── Multi-option variant picker ──
    const variantsJSON = productSection.querySelector('#cf-variants-json');
    if (variantsJSON) {
      let allVariants = [];
      try { allVariants = JSON.parse(variantsJSON.textContent); } catch(e) {}

      const selectedOptions = [];
      const optionGroups = productSection.querySelectorAll('.cf-product__variants[data-option-index]');
      optionGroups.forEach((group) => {
        const first = group.querySelector('.cf-product__variant.is-active');
        selectedOptions[parseInt(group.dataset.optionIndex, 10)] = first ? first.dataset.optionValue : null;
      });

      function findVariant() {
        return allVariants.find((v) =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
      }

      function updateProduct() {
        const match = findVariant();
        if (!match) return;
        if (priceEl) priceEl.textContent = match.price;
        if (variantInput) variantInput.value = match.id;
        setAvailability(match.available);
        if (match.image) {
          swapImage(match.image);
          thumbs.forEach((t) => {
            const on = t.dataset.img === match.image;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
        const coatingEl = productSection.querySelector('#cf-product-coating');
        if (coatingEl && selectedOptions[0]) {
          coatingEl.textContent = selectedOptions[0] === 'Silver'
            ? 'Silver PVD Coating'
            : '18K Gold PVD Coating';
        }
      }

      optionGroups.forEach((group) => {
        const optIdx = parseInt(group.dataset.optionIndex, 10);
        group.querySelectorAll('.cf-product__variant').forEach((btn) => {
          btn.addEventListener('click', () => {
            group.querySelectorAll('.cf-product__variant').forEach((b) => {
              b.classList.remove('is-active');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
            selectedOptions[optIdx] = btn.dataset.optionValue;
            updateProduct();
          });
        });
      });

      updateProduct();

    } else {
      const variants = productSection.querySelectorAll('.cf-product__variant');
      variants.forEach((btn) => {
        btn.addEventListener('click', () => {
          variants.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (btn.dataset.price && priceEl) priceEl.textContent = btn.dataset.price;
          if (btn.dataset.img) {
            swapImage(btn.dataset.img);
            thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.img === btn.dataset.img));
          }
          if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
        });
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (thumb.dataset.mediaType === 'video') {
          showVideo();
        } else {
          swapImage(thumb.dataset.img);
        }
      });
    });

    // Pause the loop while off-screen; resume when scrolled back into view.
    if (primaryVideo && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (primaryVideo.classList.contains('is-hidden')) return;
          if (e.isIntersecting) {
            const p = primaryVideo.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            primaryVideo.pause();
          }
        });
      }, { threshold: 0.15 }).observe(primaryVideo);
    }

    // ── Quantity stepper ──────────────────────────────────
    const qtyInput = productSection.querySelector('#cf-product-qty');
    productSection.querySelectorAll('.cf-product__qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const current = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.action === 'plus') {
          qtyInput.value = Math.min(current + 1, 99);
        } else {
          qtyInput.value = Math.max(current - 1, 1);
        }
      });
    });

    // ── Add to Cart intercept → open drawer ──────────────
    const productForm = productSection.querySelector('#cf-product-form');
    if (productForm && cartDrawer) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(productForm);
        const btn = productForm.querySelector('.cf-product__cta');
        const originalText = btn ? btn.textContent : '';
        if (btn) btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity'), 10) || 1,
          }),
        })
          .then((r) => r.json())
          .then(() => {
            if (btn) btn.textContent = originalText;
            openCart();
          })
          .catch(() => {
            if (btn) btn.textContent = originalText;
            productForm.submit(); // fallback
          });
      });
    }
  }
})();
